import { all, takeLatest, put, call } from 'redux-saga/effects';

import {
  apiFetchBankInfo,
  apiUpdateBankInfo,
  apiFetchBankList,
} from '@dragonfruit/services/apis';
import { actions as errorActions } from '@dragonfruit/redux/error';
import { objectSnakeCaseParser } from '@dragonfruit/utils/caseParser';

import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import {
  FETCH_BANK_INFO,
  PATCH_BANK_INFO,
  FETCH_BANK_LIST,
  fetchBankInfoSuccess,
  patchBankInfoSuccess,
  fetchBankListSuccess,
} from '@dragonfruit/redux/bank';

import { ALERT_SUCCESS_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { PASSBOOK_PIC } from '@dragonfruit/constants/bankField';

export function* fetchBankInfoFlow() {
  try {
    const bankInfo = yield call(apiFetchBankInfo);

    yield put(fetchBankInfoSuccess(bankInfo));
  } catch (error) {
    yield put(errorActions.sendError(error));
  }
}

export function* patchBankInfoFlow(action) {
  const { bankInfoData } = action.payload;
  let snakeBankInfo = objectSnakeCaseParser(bankInfoData);

  const bankFormData = new FormData();
  Object.entries(snakeBankInfo).forEach(([key, value]) => {
    if (key === PASSBOOK_PIC) return;
    bankFormData.append(key, value);
  });

  const { passbook_pic } = snakeBankInfo;
  if (!!passbook_pic.file) bankFormData.append(PASSBOOK_PIC, passbook_pic.file);

  try {
    const patchResult = yield call(apiUpdateBankInfo, bankFormData);

    yield put(
      showAlertBanner({
        message: 'account:account.bank.success',
        theme: ALERT_SUCCESS_THEME,
      })
    );
    yield put(patchBankInfoSuccess(patchResult));
  } catch (error) {
    yield put(errorActions.sendError(error));
  }
}

export function* fetchBankListFlow() {
  try {
    const bankList = yield call(apiFetchBankList);
    yield put(fetchBankListSuccess(bankList));
  } catch (error) {
    yield put(errorActions.sendError(error));
  }
}

export default function*() {
  yield all([takeLatest(FETCH_BANK_INFO, fetchBankInfoFlow)]);
  yield all([takeLatest(PATCH_BANK_INFO, patchBankInfoFlow)]);
  yield all([takeLatest(FETCH_BANK_LIST, fetchBankListFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/bank.js